// Texterna för uppföljningen i kontot (ADR 0072).
import type { components } from '../api/schema.js';

export type Uppfoljning = components['schemas']['FollowUp'];
export type Status = Uppfoljning['status'];

export const FLIKAR: { kod: Status; namn: string }[] = [
  { kod: 'awaiting_approval', namn: 'Väntar på er' },
  { kod: 'scheduled', namn: 'Planerade' },
  { kod: 'sent', namn: 'Skickade' },
  { kod: 'cancelled', namn: 'Stoppade' },
];

export const arStatus = (v: string | null): v is Status => FLIKAR.some((f) => f.kod === v);

const STATUS: Record<Status, { namn: string; chip: string }> = {
  awaiting_approval: { namn: 'Väntar på godkännande', chip: 'chip-gul' },
  scheduled: { namn: 'Planerad', chip: 'chip-gra' },
  sent: { namn: 'Skickad', chip: 'chip-gron' },
  cancelled: { namn: 'Stoppad', chip: 'chip-gra' },
};

export const statusText = (s: Status) => STATUS[s].namn;
export const statusChip = (s: Status) => STATUS[s].chip;

const ORSAK: Record<NonNullable<Uppfoljning['cancelReason']>, string> = {
  quote_accepted: 'Kunden accepterade offerten.',
  quote_declined: 'Kunden avböjde offerten.',
  quote_expired: 'Offerten gick ut.',
  quote_cancelled: 'Offerten stoppades.',
  stopped_by_firm: 'Ni stoppade uppföljningen.',
  customer_opted_out: 'Kunden avböjde fler mejl.',
  contact_removed: 'Kundens kontaktuppgifter är gallrade.',
};

export const orsakText = (o: Uppfoljning['cancelReason']) => (o ? ORSAK[o] : null);

const KALLA: Record<NonNullable<Uppfoljning['draftSource']>, string> = {
  ai: 'Skrivet av AI i er ton',
  fallback: 'Er fasta text, eftersom AI inte kunde svara',
  edited: 'Ändrat av er',
};

export const kallaText = (k: Uppfoljning['draftSource']) => (k ? KALLA[k] : null);

const STOCKHOLM = 'Europe/Stockholm';

/** "8 okt kl. 09:00". */
export const dagOchTid = (iso: string) => {
  const d = new Date(iso);
  const dag = d
    .toLocaleDateString('sv-SE', { timeZone: STOCKHOLM, day: 'numeric', month: 'short' })
    .replace('.', '');
  const tid = d.toLocaleTimeString('sv-SE', {
    timeZone: STOCKHOLM,
    hour: '2-digit',
    minute: '2-digit',
  });
  return `${dag} kl. ${tid}`;
};

/** Kunden: företaget med personen, eller bara personen. */
export function kund(u: Uppfoljning): string {
  const k = u.quote?.customer;
  if (!k) return 'Kunduppgifterna är gallrade';
  return k.companyName ? `${k.companyName} · ${k.name}` : k.name;
}
